import { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { toast } from 'material-react-toastify';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { sharedColors, sharedStyles } from '../../../../utils/Style';
import { translateContent } from '../../../../api/Translation';

interface UpsertOptionKeyDialogProps {
  open: boolean;
  onUpsert: (newValue: string) => void;
  onClose: () => void;
  initialValue?: string;
  selectedLocale: string | null;
  defaultValue?: string;
}

export const UpsertOptionKeyDialog = (props: UpsertOptionKeyDialogProps) => {
  const [value, setValue] = useState('');
  const [translating, setTranslating] = useState(false);

  useEffect(() => {
    setValue(props.initialValue ?? '');
  }, [props.initialValue, props.open]);

  const handleTranslate = () => {
    if (!props.selectedLocale || !props.defaultValue) return;

    setTranslating(true);
    translateContent(props.defaultValue, props.selectedLocale)
      .then(setValue)
      .catch((err) => toast.error(err.message))
      .finally(() => setTranslating(false));
  };

  const isValid = !isEmpty(value);

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogTitle sx={{ ...sharedStyles.h6, color: sharedColors.gray6 }}>
        {props.initialValue ? 'Seçeneği Düzenle' : 'Yeni Seçenek'}
      </DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box
          component='div'
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexGrow: 1,
            mt: 1.5,
            gap: 1.5,
            alignItems: 'center',
            width: 350,
          }}
        >
          <TextField
            label='Seçenek Adı'
            value={value}
            onChange={(e) => setValue(e.target.value)}
            size='small'
            error={!isValid}
            fullWidth
          />

          {!!props.selectedLocale && (
            <>
              <Button
                variant='outlined'
                startIcon={<AutoAwesomeIcon />}
                onClick={handleTranslate}
                sx={{ ...sharedStyles.buttonText }}
              >
                Çevir
              </Button>

              {translating && <CircularProgress size={24} />}
            </>
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 2.5, pb: 1.5 }}>
        <Button
          variant='contained'
          color='inherit'
          onClick={props.onClose}
          sx={sharedStyles.buttonText}
        >
          İptal
        </Button>
        <Button
          variant='contained'
          color='primary'
          disabled={!isValid}
          onClick={() => props.onUpsert(value)}
          sx={sharedStyles.buttonText}
        >
          Onayla
        </Button>
      </DialogActions>
    </Dialog>
  );
};
